// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4":"460b7753","119":"a7696653","123":"20d79e4f","220":"41774b6b","250":"d5c1c3d5","587":"e529d60f","594":"24384e7a","923":"11478b98","936":"3312a745"}[chunkId] + ".chunk.css";
};